
import { Component, Vue } from 'vue-property-decorator'
import Empty from '@/components/Empty/index.vue'
import { UserModule } from '@/store/modules/user'
import {
  getCouponList,
  createCoupon,
  updateCoupon,
  deleteCoupon,
  CouponTemplate
} from '@/api/coupon'

@Component({
  name: 'Coupon',
  components: {
    Empty
  }
})
export default class extends Vue {
  private tableData: any[] = []
  private searchName: string = ''
  private searchStatus: number | null = null
  private searchType: number | null = null
  private isSearch: boolean = false

  private dialogVisible: boolean = false
  private form: CouponTemplate = {
    name: '',
    type: 1,
    amount: 0,
    minAmount: 0,
    status: 1
  }
  private validRange: string[] | null = null

  private rules: any = {
    name: [{ required: true, message: '请输入券名称', trigger: 'blur' }],
    type: [{ required: true, message: '请选择类型', trigger: 'change' }],
    amount: [{ required: true, message: '请输入面额', trigger: 'change' }]
  }

  get currentStoreId() {
    return UserModule.storeId
  }

  created() {
    this.loadList()
  }

  private formatType(type: number) {
    if (type === 10) return '邀请奖励券'
    return '满减券'
  }

  private formatDate(v: string | null | undefined) {
    if (!v) return ''
    return v.replace('T', ' ')
  }

  private async loadList() {
    const params: any = {}
    if (this.searchStatus !== null) params.status = this.searchStatus
    if (this.searchType !== null) params.type = this.searchType
    if (this.currentStoreId) params.storeId = Number(this.currentStoreId)
    this.isSearch = !!this.searchName || this.searchStatus !== null || this.searchType !== null
    try {
      const res: any = await getCouponList(params)
      if (res.data.code === 1) {
        let list: any[] = res.data.data || []
        if (this.searchName) {
          const key = this.searchName.trim()
          list = list.filter(item => item.name && item.name.indexOf(key) !== -1)
        }
        this.tableData = list
      }
    } catch (err) {
      this.$message.error('请求出错了：' + err.message)
    }
  }

  private openDialog(row?: any) {
    if (row) {
      this.form = {
        id: row.id,
        name: row.name,
        type: row.type,
        amount: row.amount,
        minAmount: row.minAmount,
        status: row.status,
        storeId: row.storeId,
        validFrom: row.validFrom,
        validTo: row.validTo
      }
      this.validRange = row.validFrom || row.validTo ? [row.validFrom, row.validTo] : null
    } else {
      this.form = {
        name: '',
        type: 1,
        amount: 0,
        minAmount: 0,
        status: 1,
        storeId: this.currentStoreId ? Number(this.currentStoreId) : null
      }
      this.validRange = null
    }
    this.dialogVisible = true
    this.$nextTick(() => {
      const formRef: any = this.$refs.formRef
      if (formRef && typeof formRef.clearValidate === 'function') {
        formRef.clearValidate()
      }
    })
  }

  private handleSubmit() {
    (this.$refs.formRef as any).validate(async (valid: boolean) => {
      if (!valid) return
      try {
        const payload: any = { ...this.form }
        if (this.validRange && this.validRange.length === 2) {
          payload.validFrom = this.validRange[0]
          payload.validTo = this.validRange[1]
        } else {
          payload.validFrom = null
          payload.validTo = null
        }
        if (!this.currentStoreId) {
          this.$message.warning('请先在顶栏选择商户')
          return
        }
        payload.storeId = Number(this.currentStoreId)
        if (payload.id) {
          await updateCoupon(payload)
        } else {
          await createCoupon(payload)
        }
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.loadList()
      } catch (err) {
        this.$message.error('保存失败：' + err.message)
      }
    })
  }

  private handleDelete(row: any) {
    this.$confirm('确认删除该优惠券模板吗？', '提示', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async () => {
      try {
        if (row.id) {
          await deleteCoupon(row.id)
          this.$message.success('删除成功')
          this.loadList()
        }
      } catch (err) {
        this.$message.error('删除失败：' + err.message)
      }
    })
  }
}
